module.exports = __webpack_public_path__ + "static/media/rubyonrails.d14c7211.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rubyonrails.png
// module id = 334
// module chunks = 0